/* eslint-disable no-useless-catch */
import {SchemasOrderEasyBooking} from '@shared/schemas/order'

import getApi from '@web/helpers/api'

function getUrl(url = '') {
    return '/orderSheet/easyBooking' + url
}

const orderApi = getApi(`/orderApi`)

/**
 * 주문서 조회
 */
async function fetchOrderSheetInfo(orderSheetId: string): Promise<SchemasOrderEasyBooking['/']['response']> {
    try {
        const userAgent = navigator.userAgent
        const {
            data: {result},
        } = await orderApi.get(getUrl(), {params: {orderSheetId, userAgent}})
        return result
    } catch (e) {
        throw e
    }
}

export default {
    fetchOrderSheetInfo,
}
